import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { changeTab } from '../../../features/createBudget/createBudgetSlice';
import { useBudgetApi } from './useSetBudgetApi';
import { useBudgetValidation } from './useBudgetValidation';

export const useSetBudgetForm = () => {
  const dispatch = useDispatch();
  const { tab, formData } = useSelector(state => state.createBudget);
  const params = useParams();
  
  const { fetchBudgetData, checkBudgetName } = useBudgetApi();
  const { validateForm } = useBudgetValidation();

  useEffect(() => {
    if (params.id) {
      fetchBudgetData(params.id);
    }
  }, [params.id, fetchBudgetData]);

  const handleTabChange = useCallback((newTab) => {
    dispatch(changeTab(newTab));
  }, [dispatch]);

  const handleContinue = useCallback(async () => {
    const isFormValid = validateForm(formData, tab);
    
    if (!isFormValid) {
      return;
    }

    const result = await checkBudgetName(formData.name, params.id);
    
    return result;
  }, [formData, tab, validateForm, checkBudgetName, params.id]);

  return {
    tab,
    formData,
    isEditMode: params.id && !isNaN(params.id),
    handleTabChange,
    handleContinue,
  };
};